import Vue from 'vue'
import store from '@/store'
let HintTableFatherDlgConstructor = Vue.extend(require('./main.vue'))

let instance

var hintTableFatherDlg = function (options) {
  options = options || {}
  if (!instance) {
    instance = new HintTableFatherDlgConstructor({
      data: options,
      store: store
    })
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }

  // instance.vm.loadData()
  console.log('options=', options)
  instance.vm.tmguid = options.tmguid
  instance.vm.show = true
  return instance.vm
}

export default hintTableFatherDlg



// WEBPACK FOOTER //
// ./src/components/hintTableFatherDlg/src/main.js